/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alert[_ngcontent-%COMP%]{margin-bottom:4px;padding:2px}.tb-border[_ngcontent-%COMP%]{border:2px solid #9cc3e5}.tb-border[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-right:1px solid #9cc3e5}td[_ngcontent-%COMP%]{padding-top:3px;padding-bottom:3px}"];
export { styles as styles };
